export const ISSUE_SUMMARY_MODAL = {
    item: 'Item',
    quantityDelivered: 'Quantity',
    reasonId: 'Issue'
};

export const ASSET_SUMMARY_TABLE = {
    assetName: "Type",
    deliveredQuantity: "Delivered",
    recievedQuantity: "Recieved"
}
